import { TeamPreview, UserPreview } from '@main/access-control-types';
import type { SchemaToType } from '@main/schema-utils';
import { mkInput, mkType } from '@main/schema-utils';

export const ComplianceReportsFilterInput = mkInput({
  name: 'ComplianceReportsFilterInput',
  comment: 'Input for filtering compliance reports',
  fields: {
    ids: {
      comment: 'The ids of the targeted compliance reports',
      type: 'id',
      modelName: 'complianceReport',
      list: true,
      optional: true,
    },
  },
});

/** Override type */
export type ComplianceReportsFilterInput = SchemaToType<
  typeof ComplianceReportsFilterInput
>;

export const ComplianceReport = mkType({
  name: 'ComplianceReport',
  comment: 'Compliance report of the organization',
  fields: {
    id: {
      comment: 'The unique ID of the compliance report',
      modelName: 'complianceReport',
      type: 'id',
    },
    createdAt: {
      comment: 'The time the compliance report was created',
      type: 'Date',
    },
    creator: {
      comment: 'The user who created the compliance report',
      type: UserPreview,
      optional: true,
    },
    title: {
      comment: 'The title of the compliance report',
      type: 'string',
    },
    description: {
      comment: 'The description of the compliance report',
      type: 'string',
      optional: true,
    },
    dataProtectionOfficer: {
      comment:
        'The user who is the data protection officer for the compliance report',
      type: UserPreview,
      optional: true,
    },
    teams: {
      comment:
        'The list of teams who are responsible for managing this compliance report',
      list: true,
      type: TeamPreview,
    },
    owners: {
      comment:
        'The list of users who are responsible for managing this compliance report',
      list: true,
      type: UserPreview,
    },
  },
});

/** Override type */
export type ComplianceReport = SchemaToType<typeof ComplianceReport>;
